import { RouteConfig } from "vue-router";

export const REmployeesBrowseOld: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "employees-browse-old" */
      "./VEmployeesBrowseOld.vue"
    ),
  meta: {
    title: "Employees",
  },
};
